<v-container class="align-self-start" fluid><v-row v-if="model"><v-col cols="12"><DTable :model="model" :key="model"></DTable></v-col></v-row></v-container>